import { useQuery } from "@tanstack/react-query";
import { fetchWithError } from "src/react-query/fetchWithError";
import { queryKeys } from "src/react-query/queryKeys";
import { selector } from "src/react-query/select";

export const useRoles = () => {
  return useQuery(queryKeys.roles(), fetchWithError, { select: selector });
};
